import { IVariantType } from '~/modules/campaign/types';
import { create } from 'zustand';

interface IPathAnalysisCampaignState {
  selectedVariantType: IVariantType;
}

interface IPathAnalysisCampaignActions {
  setSelectedVariantType: (selectedVariantType: IVariantType) => void;
  reset: () => void;
}

interface IPathAnalysisCampaignStore
  extends IPathAnalysisCampaignState, IPathAnalysisCampaignActions {}

const DEFAULT_STATE: IPathAnalysisCampaignState = {
  selectedVariantType: IVariantType.VARIANT_A,
};

/**
 * Holds the A/B variant currently selected in the path-analysis / journey UI. The legacy
 * campaignPaths response cache lived here too; it was removed when campaignPaths migrated to
 * GemxQL (which caches via react-query) and its WebSocket layer was dropped.
 */
export const usePathAnalysisCampaignStore = create<IPathAnalysisCampaignStore>()((set) => ({
  ...DEFAULT_STATE,
  setSelectedVariantType: (selectedVariantType) => set({ selectedVariantType }),
  reset: () => set(DEFAULT_STATE),
}));
